import { GlobalState } from 'types';
import { WorkshopsState } from 'types/learner';

export const getWorkshopList = (state: GlobalState): WorkshopsState =>
  state.learner.workshops;
